// services/review.service.ts
import axiosInstance from "."; // Assuming this is your configured axios instance

// Interface for type safety (optional but recommended)
interface ReviewBody {
  productId: string;
  rating: number;
  comment?: string;
}

interface UpdateReviewBody {
  rating?: number;
  comment?: string;
}

// Add a new review
export const addReviewAPI = async ({ body }: { body: ReviewBody }) => {
  const response = await axiosInstance.post(`/reviews`, body);
  return response;
};

// Get all reviews
export const getAllReviewsAPI = async () => {
  const response = await axiosInstance.get(`/reviews`);
  return response;
};

// Get reviews for a specific product
export const getProductReviewsAPI = async ({ productId }: { productId: string }) => {
  const response = await axiosInstance.get(`/reviews/products/${productId}`);
  return response;
};

// Update a review
export const updateReviewAPI = async ({ reviewId, body }: { reviewId: string; body: UpdateReviewBody }) => {
  const response = await axiosInstance.patch(`/reviews/${reviewId}`, body);
  return response;
};

// Delete a review
export const deleteReviewAPI = async ({ reviewId }: { reviewId: string }) => {
  const response = await axiosInstance.delete(`/reviews/${reviewId}`);
  return response;
};

// Get reviews by user
export const getUserReviewsAPI = async () => {
  const response = await axiosInstance.get(`/reviews/user`);
  return response;
};
